<template>
  <Fragment>
    <td>
      <px-autocomplete-cadastro-adicional
        dense
        type="ARMAZEM"
        label="Depósito"
        required
        class="required rounded-tag-small"
        v-model="formData.armazem"/>
    </td>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-frag';

export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  components: {
    Fragment,
  },
};
</script>
